import { protectedRoute } from "@/utils/routeUtils";

const profileRoute = {
  path: "profile",
  title: "module_title.edit_profile",
  element: protectedRoute(
    [() => import("@/pages/profile/Profile")],
    [
      "USER",
      "SUPER_ADMIN",
      "MANAGER",
      "OFFICER",
      "DIVISION_ER_USER",
      "VISA_TEAM",
      "ONBOARDING_TEAM",
      "isRequester",
      "isReviewer",
      "isApprover",
      "isVisaReviewer",
      "isVisaApprover",
      "isVisaUser",
      "isOnboardingViewer",
      "isOnboardingApprover",
      "isOnboardingUser",
      "isHRAdmin",
      "isHRApprover",
      "isPayrollUser",
    ]
  ),
};

export default profileRoute;
